<template>
  <div
    class="container-fluid full-height overflow-hidden position-relative"
    style="padding-left:8px !important; padding-right:8px !important;"
  >
    <div
      class="position-absolute text-center d-flex align-items-center justify-content-center h-100 w-100"
      v-if="loadingBtn"
      style="z-index:999;background: rgba(0,0,0,0.8);"
    >
      <div
        class="spinner-border text-light"
        style="width: 5rem; height: 5rem;z-index:998;"
        role="status"
      >
        <span class="sr-only text-white">Loading...</span>
      </div>
    </div>
    <!-- {{gotStates}} -->
    <div class="row row1 mt-2">
      <div class="col-md-2">
        <!-- <label class="my-1 mr-2 text-white" for="inlineFormCustomSelectPref">Select State</label> -->
        <div v-if="gotStates.length > 0">
          <select
            class="custom-select my-1 mr-sm-2"
            v-model="selectState"
            id="inlineFormCustomSelectPref"
          >
            <option value="null" disabled>Select a State</option>
            <option
              v-for="(gotState, index) in gotStates"
              :key="index"
              :value="gotState"
            >{{ gotState.name }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div v-if="selectState">
          <!-- <label class="my-1 mr-2 text-white" for="inlineFormCustomSelectPref">Select Districts</label> -->
          <select
            class="custom-select my-1 mr-sm-2"
            v-model="selectDistrict"
            id="inlineFormCustomSelectPref"
          >
            <option value="null">Select a district</option>
            <option
              v-for="(district, index) in selectState.districts"
              :key="index"
              :value="district"
            >{{ district }}</option>
          </select>
        </div>
      </div>

      <div class="col-md-2">
        <div v-if="selectState">
          <!-- <label class="my-1 mr-2 text-white" for="inlineFormCustomSelectPref">Select Districts</label> -->
          <select
            class="custom-select my-1 mr-sm-2"
            v-model="selectDate"
            id="inlineFormCustomSelectPref"
          >
            <option value="null">Select a Date range</option>
            <option value="last5days">5 days</option>
            <option value="last10days">10 days</option>
            <option value="last15days">15 days</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <div v-if="selectDate">
          <button
            type="button"
            class="btn btn-primary my-1"
            @click="togglePlayer"
            :disabled="disable"
          >{{player ? "pause" : "Preview"}}</button>
        </div>
      </div>
      <!-- <div class="col-md-1">
        <button type="button" class="btn btn-warning my-1" @click="stop = !stop">Pause</button>
      </div>-->
      <div class="col-md-3" v-if="selectState">
        <p
          class="text-white my-2"
          style="font-size: 24px;"
        >Date: {{storeTransitionLoopData != null ? storeTransitionLoopData[1].date : ""}}</p>
      </div>

      <!-- <div class="col-md-4">
      </div>-->
    </div>

    <div class="row row2">
      <div class="col-md-4 pr-0 full-height">
        <div class="row ht18">
          <div class="col-md-6 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <h6>Total number of Small Growers</h6>
              <h3
                style="color:#7eff47;"
              >{{ storeTransitionLoopData != null ? storeTransitionLoopData[1].totalGrowers : 0 }}</h3>
            </div>
          </div>
          <div class="col-md-6 pl-2 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <h6>Total area under plantation</h6>
              <h4
                style="color:#7eff47;"
              >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].total_plantation : 0}} Ha</h4>
            </div>
          </div>
        </div>
        <div class="row ht38 middlerow">
          <div class="col-md-8 pr-0 full-height">
            <div class="card bg-dark full-height px-4 pb-2">
              <doughnutmalefemale-chart
                :chart-data="datacollectionDoughnutMaleFemale"
                :options="options"
                :style="myStyles"
              ></doughnutmalefemale-chart>
            </div>
          </div>
          <div class="col-md-4 pl-0 full-height">
            <div class="card bg-dark full-height px-4 py-5">
              <div class="mt-1">
                <span class="maleCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">Male:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].Male_count : 0}}</span>
              </div>
              <div class="mt-1">
                <span class="femaleCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">Female:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].Female_count : 0}}</span>
              </div>
              <div class="mt-3">
                <span class="STCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">ST:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].ST : 0}}</span>
              </div>
              <div class="mt-1">
                <span class="SCCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">SC:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].SC : 0}}</span>
              </div>
              <div class="mt-1">
                <span class="OBCCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">OBC:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].OBC : 0}}</span>
              </div>
              <div class="mt-1">
                <span class="MOBCCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">MOBC:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].MOBC : 0 }}</span>
              </div>
              <div class="mt-1">
                <span class="GENCircle"></span>
                <span class="text-white pl-2" style="font-size: 15px;">GEN:</span>
                <span
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].GEN : 0 }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row ht40">
          <div class="col-md-12 full-height">
            <div class="card bg-dark full-height">
              <barareavsgrower-chart
                :chart-data="datacollectionBarAreaVsGrowerCode"
                :options="optionsbarareavsgrower"
                :styles="myStyles"
              ></barareavsgrower-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-8 full-height">
        <div class="row ht18">
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <h6>Total Number of Factories</h6>
              <h3
                style="color:#7eff47;"
              >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].totalFactory : 0}}</h3>
            </div>
          </div>
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <h6>Total Installed Capacity</h6>
              <h3
                style="color:#7eff47;"
              >{{ storeTransitionLoopData != null ? storeTransitionLoopData[1].Installed_Capacity : 0 }} kg</h3>
            </div>
          </div>
          <div class="col-md-4 pl-2 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <h6>Total Production(2020-2021)</h6>
              <h3 style="color:#7eff47;">90876</h3>
            </div>
          </div>
        </div>
        <div class="row ht38 middlerow">
          <div class="col-md-6 pl-2 pr-0 full-height">
            <div class="card bg-dark full-height px-4">
              <barqrcode-chart
                :chart-data="datacollectionStackedBarQrCode"
                :options="optionsStackedBar"
                :styles="myStyles"
              ></barqrcode-chart>
            </div>
          </div>
          <div class="col-md-6 pl-2 full-height">
            <div class="card bg-dark bg-dark full-height px-4">
              <piefactorycatg-chart
                :chart-data="datacollectionFactoryCatgPie"
                :options="optionspie"
                :style="myStyles"
              ></piefactorycatg-chart>
            </div>
          </div>
        </div>
        <div class="row ht19">
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>Number of Registered Factories</h6>
              </div>
              <div>
                <h3
                  style="color:#7eff47;"
                >{{storeTransitionLoopData != null ? storeTransitionLoopData[1].Registered_Factory : 0}}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>Factories Location Updated</h6>
              </div>
              <div>
                <h3
                  style="color:#7eff47;"
                >{{ storeTransitionLoopData != null ? storeTransitionLoopData[1].Updated_factory_location : 0 }} / {{ storeTransitionLoopData != null ? storeTransitionLoopData[1].totalFactory : 0 }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 pl-2 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>Growers Location Updated</h6>
              </div>
              <div>
                <h3
                  style="color:#7eff47;"
                >{{ storeTransitionLoopData != null ? storeTransitionLoopData[1].GrowerUpdatedLocation : 0 }} / {{ storeTransitionLoopData != null ? storeTransitionLoopData[1].totalGrowers : 0 }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="row ht20 lastrow">
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>QR Generation Progress</h6>
              </div>
              <div>
                <h3 style="color:#7eff47;">{{0}}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 pl-2 pr-0 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>Average Green-Leaf Price</h6>
              </div>
              <div>
                <h3 style="color:#7eff47;">{{2 | indianrupee }}</h3>
              </div>
            </div>
          </div>
          <div class="col-md-4 pl-2 full-height">
            <div
              class="card bg-dark full-height text-white d-flex justify-content-center align-items-center"
            >
              <div>
                <h6>Average Minimum Benchmark Price</h6>
              </div>
              <div>
                <h3 style="color:#7eff47;">{{2 | indianrupee }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import indianrupee from "../filters";
import { mapActions } from "vuex";
import stateService from "../api/stateService";
import factoryService from "../api/factoriesService";
import districtService from "../api/districtService";
// import axios from "axios";
// import LineChart from "./charts/LineChart.js";
// import BarChart from "./charts/BarChart.js";
// import PieChart from "./charts/PieChart.js";
import DoughnutmalefemaleChart from "../components/charts/DoughnutmalefemaleChart.js";
import BarqrcodeChart from "../components/charts/BarqrcodeChart.js";
import BarareavsgrowerChart from "../components/charts/BarareavsgrowerChart.js";
import DoughnutcasteChart from "../components/charts/DoughnutcasteChart.js";
import PiefactorycatgChart from "../components/charts/PiefactorycatgChart.js";

// import DoughnutfactoryChart from "./charts/DoughnutfactoryChart.js";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var index = tooltipItem.index;
        return dataset.labels[index] + ": " + dataset.data[index];
      }
    }
  },
  pieceLabel: {
    mode: "value"
  },
  cutoutPercentage: 50,
  segmentShowStroke: false,

  animation: {
    animateRotate: true,
    animateScale: true
  },
  legend: {
    display: false
    // position: "right",
    // labels: {
    //   // This more specific font property overrides the global property
    //   fontColor: "white"
    // }
  },
  title: {
    display: true,
    fontColor: "white",
    fontSize: 15,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif",
    text: "Small Tea Growers Distribution(Gender wise & Caste wise)"
  }
  // rotation: 1 * Math.PI,
  // circumference: 1 * Math.PI
};

const optionsbar = {
  responsive: true,
  maintainAspectRatio: false,
  // tooltips: { enabled: false },
  legend: {
    // position: "right",
    labels: {
      // This more specific font property overrides the global property
      fontColor: "white"
    }
  },
  scales: {
    yAxes: [
      {
        display: true,
        ticks: {
          fontColor: "white"
        }
      }
    ],
    xAxes: [
      {
        display: true,
        ticks: {
          fontColor: "white"
        }
      }
    ]
  },
  title: {
    display: true,
    fontColor: "white",
    fontSize: 14,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif",
    text: "QR code generation progress"
  }
};

const optionsbarareavsgrower = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: { enabled: true },
  legend: {
    // position: "right",
    labels: {
      // This more specific font property overrides the global property
      fontColor: "white"
    }
  },
  scales: {
    yAxes: [
      {
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Number of Growers",
          fontColor: "white"
        },
        ticks: {
          fontColor: "white"
        }
      }
    ],
    xAxes: [
      {
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Area Under Plantation",
          fontColor: "white"
        },
        ticks: {
          fontColor: "white"
        }
      }
    ]
  },
  title: {
    display: true,
    fontColor: "white",
    fontSize: 14,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif"
    // text: "Number of growers under certain area of plantation "
  }
};

const optionssemidough = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: { enabled: false },
  cutoutPercentage: 70,

  animation: {
    animateRotate: true,
    animateScale: true
  },
  legend: {
    // position: "right",
    labels: {
      // This more specific font property overrides the global property
      fontColor: "white"
    }
  },
  rotation: 1 * Math.PI,
  circumference: 1 * Math.PI,
  title: {
    display: true,
    fontColor: "white",
    fontSize: 14,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif",
    text: "Grower Caste-wise Distribution"
  }
};

const optionspie = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: { enabled: false },
  animation: {
    animateRotate: true,
    animateScale: true
  },
  legend: {
    // position: "right",
    labels: {
      // This more specific font property overrides the global property
      fontColor: "white"
    }
  },
  title: {
    display: true,
    fontColor: "white",
    fontSize: 14,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif",
    text: "Factory Category"
  }
};
const optionsStackedBar = {
  responsive: true,
  maintainAspectRatio: false,
  // // tooltips: { enabled: false },
  // legend: {
  //   // position: "right",
  //   labels: {
  //     // This more specific font property overrides the global property
  //     fontColor: "white"
  //   },
  legend: {
    // position: "right",
    labels: {
      // This more specific font property overrides the global property
      fontColor: "white"
    }
  },
  scales: {
    xAxes: [
      {
        stacked: true,
        scaleLabel: {
          fontColor: "white"
        },
        ticks: {
          fontColor: "white"
        }
      }
    ],
    yAxes: [
      {
        stacked: true,
        ticks: {
          fontColor: "white"
        }
      }
    ]
  },
  title: {
    display: true,
    fontColor: "white",
    fontSize: 14,
    fontFamily: "'Helvetica Neue',Helvetica, Arial, sans-serif",
    text: "Green Leaf Quality-wise Distribution"
  }
};

export default {
  components: {
    // LineChart,
    // BarChart,
    // PieChart,
    DoughnutmalefemaleChart,
    BarqrcodeChart,
    BarareavsgrowerChart,
    DoughnutcasteChart,
    PiefactorycatgChart
    // DoughnutfactoryChart
  },
  data() {
    return {
      stop: false,
      disable: false,
      testTransitionArr: [],
      storeTransitionLoopData: null,
      testTransition: {
        day1: {
          totalGrowers: 25308,
          total_plantation: 18919.82,
          pending: 8485,
          processing: 857,
          onprint: 123,
          downloaded: 0,
          dispatched: 10414,
          printed: 5429,
          Male_count: 23605,
          Female_count: 1628,
          ST: 4106,
          SC: 705,
          OBC: 16169,
          MOBC: 1546,
          GEN: 2047,
          uptoTwo: 23771,
          uptoFour: 968,
          uptoSix: 176,
          uptoEight: 85,
          uptoTen: 52,
          Grower_count: 0,
          district: "Dibrugarh",
          totalFactory: 785,
          BLF: 277,
          EF: 0,
          IT: 0,
          Installed_Capacity: 824715391,
          Registered_Factory: 218,
          Updated_factory_location: 0,
          date: "02-03-2020"
        },
        day2: {
          totalGrowers: 28993,
          total_plantation: 27656.98,
          pending: 12610,
          processing: 206,
          onprint: 0,
          downloaded: 16177,
          dispatched: 0,
          printed: 0,
          ST: 1045,
          SC: 14873,
          OBC: 3773,
          MOBC: 397,
          GEN: 7870,
          Male_count: 27042,
          Female_count: 1838,
          uptoTwo: 27199,
          uptoFour: 993,
          uptoSix: 270,
          uptoEight: 123,
          uptoTen: 97,
          GrowerUpdatedLocation: 0,
          Grower_count: 28993,
          state: "West Bengal",
          totalFactory: 255,
          BLF: 184,
          EF: 0,
          IT: 0,
          Installed_Capacity: 543231212435,
          Registered_Factory: 115,
          Updated_factory_location: 0,
          date: "03-03-2020"
        },
        day3: {
          totalGrowers: 42993,
          total_plantation: 48656.98,
          pending: 4610,
          processing: 3106,
          onprint: 345,
          downloaded: 4477,
          dispatched: 34,
          printed: 87,
          ST: 2045,
          SC: 6873,
          OBC: 1773,
          MOBC: 997,
          GEN: 270,
          Male_count: 27000,
          Female_count: 1798,
          uptoTwo: 43299,
          uptoFour: 99,
          uptoSix: 1000,
          uptoEight: 500,
          uptoTen: 40000,
          GrowerUpdatedLocation: 0,
          Grower_count: 42993,
          state: "West Bengal",
          totalFactory: 645,
          BLF: 345,
          EF: 0,
          IT: 0,
          Installed_Capacity: 986715391,
          Registered_Factory: 112,
          Updated_factory_location: 0,
          date: "04-03-2020"
        },
        day4: {
          totalGrowers: 55993,
          total_plantation: 275656.98,
          pending: 20610,
          processing: 2206,
          onprint: 450,
          downloaded: 0,
          dispatched: 4560,
          printed: 1110,
          ST: 45,
          SC: 3345,
          OBC: 0,
          MOBC: 1234,
          GEN: 2234,
          Male_count: 27042,
          Female_count: 1838,
          uptoTwo: 27199,
          uptoFour: 993,
          uptoSix: 270,
          uptoEight: 123,
          uptoTen: 97,
          GrowerUpdatedLocation: 0,
          Grower_count: 55993,
          state: "West Bengal",
          totalFactory: 476,
          BLF: 235,
          EF: 0,
          IT: 0,
          Installed_Capacity: 824723456,
          Registered_Factory: 222,
          Updated_factory_location: 11,
          date: "05-03-2020"
        },
        day5: {
          totalGrowers: 28993,
          total_plantation: 27656.98,
          pending: 12610,
          processing: 206,
          onprint: 0,
          downloaded: 16177,
          dispatched: 0,
          printed: 0,
          ST: 1045,
          SC: 14873,
          OBC: 3773,
          MOBC: 397,
          GEN: 7870,
          Male_count: 27042,
          Female_count: 1838,
          uptoTwo: 27199,
          uptoFour: 993,
          uptoSix: 270,
          uptoEight: 123,
          uptoTen: 97,
          GrowerUpdatedLocation: 0,
          Grower_count: 28993,
          state: "West Bengal",
          totalFactory: 546,
          BLF: 200,
          EF: 0,
          IT: 0,
          Installed_Capacity: 200723456,
          Registered_Factory: 200,
          Updated_factory_location: 0,
          date: "06-03-2020"
        }
      },
      player: false,
      index: 0,
      count: 0,
      loadingBtn: false,
      myStyles: {
        height: "97%"
      },
      zoomControl: false,
      attributionControl: false,
      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,
      center: [28.6139, 77.209],
      markerLatLng: [28.6139, 77.209],

      gotStates: [],
      selectState: null,
      selectDistrict: null,
      selectDate: null,
      districts: [],
      options,
      optionsbar,
      optionsbarareavsgrower,
      optionssemidough,
      optionspie,
      optionsStackedBar, // cut
      // datacollectionLine: null,
      // datacollectionBar: null,
      // datacollectionPie: null,
      datacollectionDoughnutMaleFemale: null,
      datacollectionBarQrCode: null,
      datacollectionDoughnutCaste: null,
      datacollectionBarAreaVsGrowerCode: null,
      datacollectionFactoryCatgPie: null,

      datacollectionStackedBarQrCode: null, //cut

      growersDataState: {},

      district_name: "",
      state_name: "",
      factoryCtgState: {}
    };
  },
  watch: {
    selectState(newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectDistrict = null;
      }
    }
    // player(newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     console.log(newValue);
    //     this.testTransitionArr = [];
    //   }
    // }
  },
  mounted() {
    this.receiveStates();

    // this.fillDataLine();
  },
  methods: {
    ...mapActions({
      signOutAction: "auth/signOut"
    }),
    signOut() {
      this.signOutAction().then(() => {
        this.$router.replace({
          name: "login"
        });
      });
    },
    togglePlayer() {
      this.disable = !this.disable;
      // this.player = !this.player;
      console.log("length b4 foreach" + this.testTransitionArr.length);
      if (
        this.selectState != null &&
        this.selectDistrict == null &&
        this.selectDate != null
      ) {
        console.log(this.selectState.id + "   " + this.selectDate + "clicked");
        this.testTransitionArr = Object.entries(this.testTransition);
        let that = this;
        for (let index = 0; index < that.testTransitionArr.length; index++) {
          (function(index) {
            var x = setTimeout(function() {
              that.storeData(that.testTransitionArr[index]);
              let lngth = that.testTransitionArr.length - 1;
              console.log("Length is: " + lngth);
              console.log("Index is: " + index);
              console.log("Disable: " + that.disable);
              console.log(that.stop);
              if (index === lngth) {
                that.disable = !that.disable;
                console.log("Condn disable: " + that.disable);
              }
              console.log(index);
              console.log("---------*****---------");
            }, index * 5000);
          })(index);
          // that.disable = !that.disable;
          // if (index == that.testTransitionArr.length - 1) {
          //   that.disable = !that.disable;
          // }
        }
      }
      if (this.selectDistrict != null && this.selectDate != null) {
        console.log(this.selectDistrict + "   " + this.selectDate + "clicked");
        this.testTransitionArr = Object.entries(this.testTransition);
        let that = this;
        for (let index = 0; index < that.testTransitionArr.length; index++) {
          (function(index) {
            var y = setTimeout(function() {
              that.storeData(that.testTransitionArr[index]);
              let lngth = that.testTransitionArr.length - 1;
              console.log("Length is: " + lngth);
              console.log("Index is: " + index);
              console.log("Disable: " + that.disable);
              console.log(that.stop);
              if (index === lngth) {
                that.disable = !that.disable;
                console.log("Condn disable: " + that.disable);
              }
              console.log("---------*****---------");
            }, index * 5000);
          })(index);
        }
      }
    },

    storeData(value, x) {
      let that = this;
      if (that.stop == true) {
        clearInterval(x);
        // return;
      }
      this.storeTransitionLoopData = value;
      this.datacollectionDoughnutMaleFemale = {
        labels: ["Male", "Female"],
        datasets: [
          {
            labels: ["ST", "SC", "OBC", "MOBC", "GEN"],
            backgroundColor: ["red", "blue", "green", "yellow", "purple"],
            borderWidth: 0,
            data: [
              this.storeTransitionLoopData[1].ST,
              this.storeTransitionLoopData[1].SC,
              this.storeTransitionLoopData[1].OBC,
              this.storeTransitionLoopData[1].MOBC,
              this.storeTransitionLoopData[1].GEN
            ]
          },
          {
            labels: ["Male", "Female"],
            backgroundColor: ["#464dee", "#0ddbb9"],
            borderWidth: 0,
            data: [
              this.storeTransitionLoopData[1].Male_count,
              this.storeTransitionLoopData[1].Female_count
            ]
          }
        ]
      };
      this.datacollectionStackedBarQrCode = {
        labels: [""],
        datasets: [
          {
            label: "Low",
            data: [67.8],
            backgroundColor: "#006D2C" // green
          },
          {
            label: "Moderate",
            data: [20.7],
            backgroundColor: "#31A354" // yellow
          },
          {
            label: "High",
            data: [11.4],
            backgroundColor: "#74C476" // red AABAD7
          }
        ]
      };
      this.datacollectionBarAreaVsGrowerCode = {
        labels: ["0-2 ha", "2.1-4 ha", "4.1-6 ha", "6.1-8 ha", "8.1-10.2"],
        datasets: [
          {
            label: "Number of growers under certain area of Plantation",
            backgroundColor: [
              "#0ddbb9",
              "#0ddbb9",
              "#0ddbb9",
              "#0ddbb9",
              "#0ddbb9"
            ],
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            data: [
              this.storeTransitionLoopData[1].uptoTwo,
              this.storeTransitionLoopData[1].uptoFour,
              this.storeTransitionLoopData[1].uptoSix,
              this.storeTransitionLoopData[1].uptoEight,
              this.storeTransitionLoopData[1].uptoTen
            ]
          }
        ]
      };
      this.datacollectionFactoryCatgPie = {
        labels: [
          "BLF:  " + this.storeTransitionLoopData[1].BLF,
          "EF:  " + this.storeTransitionLoopData[1].EF,
          "IT:  " + this.storeTransitionLoopData[1].IT
        ],
        datasets: [
          {
            label: "Data One",
            backgroundColor: ["#f6e84e", "#5e50f9", "#0ddbb9"],
            borderWidth: 0,
            data: [
              this.storeTransitionLoopData[1].BLF,
              this.storeTransitionLoopData[1].EF,
              this.storeTransitionLoopData[1].IT
            ]
          }
        ]
      };
    },
    // togglePlayer() {
    //   // this.player = !this.player;
    //   this.index++;
    //   let timer = setInterval(
    //     () => this.assignTransitionData(this.index),
    //     5000
    //   );
    //   if (!this.player) {
    //     // this.previewData();
    //     setTimeout(() => {
    //       clearInterval(timer);
    //     }, 5000);
    //   }
    // },
    // assignTransitionData(index) {
    //   var testTransitionArr = Object.entries(this.testTransition);
    //   this.totalGrowers = testTransitionArr[index][1].totalGrowers;

    //   this.total_plantation = testTransitionArr[index][1].total_plantation;
    //   this.Male_count = testTransitionArr[index][1].Male_count;
    //   this.Female_count = testTransitionArr[index][1].Female_count;
    //   this.ST = testTransitionArr[index][1].ST;
    //   this.SC = testTransitionArr[index][1].SC;
    //   this.OBC = testTransitionArr[index][1].OBC;
    //   this.MOBC = testTransitionArr[index][1].MOBC;
    //   this.GEN = testTransitionArr[index][1].GEN;
    //   this.total = testTransitionArr[index][1].total;
    //   this.Installed_Capacity = testTransitionArr[index][1].Installed_Capacity;
    //   this.Registered_Factory = testTransitionArr[index][1].Registered_Factory;
    //   this.totalFactory = testTransitionArr[index][1].totalFactory;

    //   this.Updated_factory_location =
    //     testTransitionArr[index][1].Updated_factory_location;
    //   this.GrowerUpdatedLocation =
    //     testTransitionArr[index][1].GrowerUpdatedLocation;

    //   this.datacollectionDoughnutMaleFemale = {
    //     labels: ["Male", "Female"],
    //     datasets: [
    //       {
    //         labels: ["ST", "SC", "OBC", "MOBC", "GEN"],
    //         backgroundColor: ["red", "blue", "green", "yellow", "purple"],
    //         borderWidth: 0,
    //         data: [
    //           testTransitionArr[index][1].ST,
    //           testTransitionArr[index][1].SC,
    //           testTransitionArr[index][1].OBC,
    //           testTransitionArr[index][1].MOBC,
    //           testTransitionArr[index][1].GEN
    //         ]
    //       },
    //       {
    //         labels: ["Male", "Female"],
    //         backgroundColor: ["#464dee", "#0ddbb9"],
    //         borderWidth: 0,
    //         data: [
    //           testTransitionArr[index][1].Male_count,
    //           testTransitionArr[index][1].Female_count
    //         ]
    //       }
    //     ]
    //   };
    //   this.datacollectionStackedBarQrCode = {
    //     labels: [""],
    //     datasets: [
    //       {
    //         label: "Low",
    //         data: [67.8],
    //         backgroundColor: "#006D2C" // green
    //       },
    //       {
    //         label: "Moderate",
    //         data: [20.7],
    //         backgroundColor: "#31A354" // yellow
    //       },
    //       {
    //         label: "High",
    //         data: [11.4],
    //         backgroundColor: "#74C476" // red AABAD7
    //       }
    //     ]
    //   };
    //   this.datacollectionBarAreaVsGrowerCode = {
    //     labels: ["0-2 ha", "2.1-4 ha", "4.1-6 ha", "6.1-8 ha", "8.1-10.2"],
    //     datasets: [
    //       {
    //         label: "Number of growers under certain area of Plantation",
    //         backgroundColor: [
    //           "#0ddbb9",
    //           "#0ddbb9",
    //           "#0ddbb9",
    //           "#0ddbb9",
    //           "#0ddbb9"
    //         ],
    //         pointBackgroundColor: "white",
    //         borderWidth: 0,
    //         pointBorderColor: "#249EBF",
    //         data: [
    //           testTransitionArr[index][1].uptoTwo,
    //           testTransitionArr[index][1].uptoFour,
    //           testTransitionArr[index][1].uptoSix,
    //           testTransitionArr[index][1].uptoEight,
    //           testTransitionArr[index][1].uptoTen
    //         ]
    //       }
    //     ]
    //   };
    //   this.datacollectionFactoryCatgPie = {
    //     labels: [
    //       "BLF:  " + testTransitionArr[index][1].BLF,
    //       "EF:  " + testTransitionArr[index][1].EF,
    //       "IT:  " + testTransitionArr[index][1].IT
    //     ],
    //     datasets: [
    //       {
    //         label: "Data One",
    //         backgroundColor: ["#f6e84e", "#5e50f9", "#0ddbb9"],
    //         borderWidth: 0,
    //         data: [
    //           testTransitionArr[index][1].BLF,
    //           testTransitionArr[index][1].EF,
    //           testTransitionArr[index][1].IT
    //         ]
    //       }
    //     ]
    //   };
    // },

    receiveStates() {
      this.loadingBtn = true;
      stateService
        .getStates()
        .then(response => {
          this.loadingBtn = false;
          this.gotStates = response.data.data;
        })
        .catch();
    },

    stateSelected(selectedStateId) {
      this.getGrowersDataState(selectedStateId);
      this.factoryCatgState(selectedStateId);
    },
    getGrowersDataState(selectedStateId) {
      this.loadingBtn = true;
      stateService
        .getGrowersDataOfStateByStateId(selectedStateId)
        .then(response => {
          this.loadingBtn = false;
          this.growersDataState = response.data.data;
          this.state_name = response.data.state;
          this.datacollectionDoughnutMaleFemale = {
            labels: ["Male", "Female"],
            datasets: [
              {
                labels: ["ST", "SC", "OBC", "MOBC", "GEN"],
                backgroundColor: ["red", "blue", "green", "yellow", "purple"],
                borderWidth: 0,
                data: [
                  this.growersDataState.ST,
                  this.growersDataState.SC,
                  this.growersDataState.OBC,
                  this.growersDataState.MOBC,
                  this.growersDataState.GEN
                ]
              },
              {
                labels: ["Male", "Female"],
                backgroundColor: ["#464dee", "#0ddbb9"],
                borderWidth: 0,
                data: [
                  this.growersDataState.Male_count,
                  this.growersDataState.Female_count
                ]
              }
            ]
          };
          this.datacollectionStackedBarQrCode = {
            labels: [""],
            datasets: [
              {
                label: "Low",
                data: [67.8],
                backgroundColor: "#006D2C" // green
              },
              {
                label: "Moderate",
                data: [20.7],
                backgroundColor: "#31A354" // yellow
              },
              {
                label: "High",
                data: [11.4],
                backgroundColor: "#74C476" // red AABAD7
              }
            ]
          };
          this.datacollectionBarQrCode = {
            labels: [
              "Pending",
              "Processing",
              "On-Print",
              "Downloaded",
              "Dispatched",
              "Printed"
            ],
            datasets: [
              {
                label: "QR code generation Progress",
                barThickness: 16,
                maxBarThickness: 16,
                minBarLength: 0,
                backgroundColor: [
                  "#748adb",
                  "#5d6675",
                  "#a1aacc",
                  "#6c88f5",
                  "#b0ceff",
                  "#00ffd0"
                ],
                pointBackgroundColor: "white",
                borderWidth: 0,
                pointBorderColor: "#249EBF",
                data: [
                  this.growersDataState.pending,
                  this.growersDataState.processing,
                  this.growersDataState.onprint,
                  this.growersDataState.downloaded,
                  this.growersDataState.dispatched,
                  this.growersDataState.printed
                ]
              }
            ]
          };
          this.datacollectionBarAreaVsGrowerCode = {
            labels: ["0-2 ha", "2.1-4 ha", "4.1-6 ha", "6.1-8 ha", "8.1-10.2"],
            datasets: [
              {
                label: "Number of growers under certain area of Plantation",
                backgroundColor: [
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9"
                ],
                pointBackgroundColor: "white",
                borderWidth: 0,
                pointBorderColor: "#249EBF",
                data: [
                  this.growersDataState.uptoTwo,
                  this.growersDataState.uptoFour,
                  this.growersDataState.uptoSix,
                  this.growersDataState.uptoEight,
                  this.growersDataState.uptoTen
                ]
              }
            ]
          };
          this.datacollectionDoughnutCaste = {
            //
            labels: [
              "ST:  " + this.growersDataState.ST,
              "SC:  " + this.growersDataState.SC,
              "OBC:  " + this.growersDataState.OBC,
              "MOBC:  " + this.growersDataState.MOBC,
              "GEN:  " + this.growersDataState.GEN
            ],
            datasets: [
              {
                label: "Data One",
                backgroundColor: [
                  "#57c7d4",
                  "#f6e84e",
                  "#46c35f",
                  "#f96868",
                  "#f2a654"
                ],
                borderWidth: 0,
                data: [
                  this.growersDataState.ST,
                  this.growersDataState.SC,
                  this.growersDataState.OBC,
                  this.growersDataState.MOBC,
                  this.growersDataState.GEN
                ]
              }
            ]
          };
          this.center = this.growersDataState.location;
          this.markerLatLng = this.growersDataState.location;
        })
        .catch();
    },

    factoryCatgState(selectedStateId) {
      factoryService
        .getFactoryCategoryByStateId(selectedStateId)
        .then(response => {
          this.factoryCtgState = response.data.data;
          this.datacollectionFactoryCatgPie = {
            labels: [
              "BLF:  " + this.factoryCtgState.BLF,
              "EF:  " + this.factoryCtgState.EF,
              "IT:  " + this.factoryCtgState.IT
            ],
            datasets: [
              {
                label: "Data One",
                backgroundColor: ["#f6e84e", "#5e50f9", "#0ddbb9"],
                borderWidth: 0,
                data: [
                  this.factoryCtgState.BLF,
                  this.factoryCtgState.EF,
                  this.factoryCtgState.IT
                ]
              }
            ]
          };
        })
        .catch();
    },

    districtSelected(selectedDistrictName) {
      if (this.selectDistrict == null) {
        return;
      }
      this.getGrowersDataDistrict(selectedDistrictName);
      this.factoryCatgDistrict(selectedDistrictName);
    },
    getGrowersDataDistrict(selectedDistrictName) {
      this.growersDataState = {};
      this.loadingBtn = true;
      districtService
        .getGrowersDataOfDistrictByDistrictName(selectedDistrictName)
        .then(response => {
          this.loadingBtn = false;
          this.growersDataState = response.data.data;
          this.district_name = response.data.district;
          this.datacollectionDoughnutMaleFemale = {
            labels: ["Male", "Female"],
            datasets: [
              {
                labels: ["ST", "SC", "OBC", "MOBC", "GEN"],
                backgroundColor: ["red", "blue", "green", "yellow", "purple"],
                borderWidth: 0,
                data: [
                  this.growersDataState.ST,
                  this.growersDataState.SC,
                  this.growersDataState.OBC,
                  this.growersDataState.MOBC,
                  this.growersDataState.GEN
                ]
              },
              {
                labels: ["Male", "Female"],
                borderWidth: 0,
                backgroundColor: ["#464dee", "#0ddbb9"],
                data: [
                  this.growersDataState.Male_count,
                  this.growersDataState.Female_count
                ]
              }
            ]
          };
          this.datacollectionBarQrCode = {
            labels: [
              "Pending",
              "Processing",
              "On-Print",
              "Downloaded",
              "Dispatched",
              "Printed"
            ],
            datasets: [
              {
                label: "QR code generation Progress",
                barThickness: 16,
                maxBarThickness: 16,
                minBarLength: 16,
                borderWidth: 0,
                backgroundColor: [
                  "#748adb",
                  "#5d6675",
                  "#a1aacc",
                  "#6c88f5",
                  "#b0ceff",
                  "#00ffd0"
                ],
                pointBackgroundColor: "white",
                pointBorderColor: "#249EBF",
                data: [
                  this.growersDataState.pending,
                  this.growersDataState.processing,
                  this.growersDataState.onprint,
                  this.growersDataState.downloaded,
                  this.growersDataState.dispatched,
                  this.growersDataState.printed
                ]
              }
            ]
          };
          this.datacollectionBarAreaVsGrowerCode = {
            labels: ["0-2 ha", "2.1-4 ha", "4.1-6 ha", "6.1-8 ha", "8.1-10.2"],
            datasets: [
              {
                label: "Number of growers under certain area of Plantation",
                borderWidth: 0,
                backgroundColor: [
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9",
                  "#0ddbb9"
                ],
                pointBackgroundColor: "white",
                pointBorderColor: "#249EBF",
                data: [
                  this.growersDataState.uptoTwo,
                  this.growersDataState.uptoFour,
                  this.growersDataState.uptoSix,
                  this.growersDataState.uptoEight,
                  this.growersDataState.uptoTen
                ]
              }
            ]
          };
          // this.datacollectionDoughnutCaste = {
          //   labels: [
          //     "ST:  " + this.growersDataState.ST,
          //     "SC:  " + this.growersDataState.SC,
          //     "OBC:  " + this.growersDataState.OBC,
          //     "MOBC:  " + this.growersDataState.MOBC,
          //     "GEN:  " + this.growersDataState.GEN
          //   ],
          //   datasets: [
          //     {
          //       label: "Data One",
          //       borderWidth: 0,
          //       backgroundColor: [
          //         "#57c7d4",
          //         "#f6e84e",
          //         "#46c35f",
          //         "#f96868",
          //         "#f2a654"
          //       ],
          //       data: [
          //         this.growersDataState.ST,
          //         this.growersDataState.SC,
          //         this.growersDataState.OBC,
          //         this.growersDataState.MOBC,
          //         this.growersDataState.GEN
          //       ]
          //     }
          //   ]
          // };
          this.center = this.growersDataState.location;
          this.markerLatLng = this.growersDataState.location;
        })
        .catch();
    },
    factoryCatgDistrict(selectedDistrictName) {
      this.factoryCtgState = {};
      factoryService
        .getFactoryCategoryByDistrictName(selectedDistrictName)
        .then(response => {
          this.factoryCtgState = response.data.data;
          this.datacollectionFactoryCatgPie = {
            labels: [
              "BLF:  " + this.factoryCtgState.BLF,
              "EF:  " + this.factoryCtgState.EF,
              "IT:  " + this.factoryCtgState.IT
            ],
            datasets: [
              {
                label: "Data One",
                borderWidth: 0,
                backgroundColor: ["#f6e84e", "#5e50f9", "#0ddbb9"],
                data: [
                  this.factoryCtgState.BLF,
                  this.factoryCtgState.EF,
                  this.factoryCtgState.IT
                ]
              }
            ]
          };
        })
        .catch();
    }

    // fillDataLine() {
    //   this.datacollectionLine = {
    //     labels: ["January", "February", "March", "April", "May"],
    //     datasets: [
    //       {
    //         label: "Data One",
    //         backgroundColor: ["#c77722"],
    //         data: [40, 39, 10, 40, 39]
    //       }
    //     ]
    //   };
    // },
  }
};
</script>

<style>
.small {
  max-width: 600px;
  margin: 150px auto;
}
.row1 {
  height: 6%;
}
.growersdiv {
  /* margin-bottom: 4px; */
  height: 94%;
}
.ht18 {
  height: 18%;
}
/* .ht42 {
  height: 41%;
} */
.ht40 {
  height: 40%;
}
.ht20 {
  height: 20%;
}
.ht19 {
  height: 19%;
}
.ht38 {
  height: 38%;
}
.middlerow {
  margin-top: 6px;
  margin-bottom: 6px;
}
.lastrow {
  margin-top: 6px;
  margin-bottom: 6px;
}
.row2 {
  margin-bottom: 4px;
  height: 94%;
}

.ht35 {
  height: 35%;
}
.row3 {
  height: 34%;
}

.full-height {
  height: 100%;
}

.ht32 {
  height: 32%;
}
.ht33 {
  height: 33%;
}
.ht34 {
  height: 34%;
}
.ht80 {
  margin-top: 1%;
  height: 74%;
}
.ht70 {
  height: 70%;
}
.ht30 {
  height: 30%;
}
.ht50 {
  height: 50%;
}
.ht49 {
  height: 49%;
}

.maleCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: #464dee;
  border-radius: 50% 50%;
}
.femaleCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: #0ddbb9;
  border-radius: 50% 50%;
}
.STCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: red;
  border-radius: 50% 50%;
}
.SCCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: blue;
  border-radius: 50% 50%;
}
.OBCCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: green;
  border-radius: 50% 50%;
}
.MOBCCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: yellow;
  border-radius: 50% 50%;
}
.GENCircle {
  display: inline-block;
  height: 18px;
  width: 18px;
  background-color: purple;
  border-radius: 50% 50%;
}
@media only screen and (min-width: 801px) and (max-width: 1024px) {
}
@media only screen and (min-width: 1025px) and (max-width: 1366px) {
  .titleCard {
    font-size: 12px;
  }
  .cardValue {
    font-size: 22px;
  }
}
@media only screen and (min-width: 1367px) and (max-width: 1920px) {
  .titleCard {
    font-size: 14px;
  }
  .cardValue {
    font-size: 26px;
  }
}
</style>
